var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover",class:{
  'box-radius': _vm.raduis,
  'box-shadow': _vm.shadow
}},[_c('img',{attrs:{"src":_vm.cover}})])}
var staticRenderFns = []

export { render, staticRenderFns }